import step1ChangeTemplate from './tutorialAssets/step-1-change-template.png'
import step2ApplyDesign from './tutorialAssets/step-2-apply-design.png'
import step3StartCampaign from './tutorialAssets/step-3-start-campaign.png'

export const dripEmailSupportTutorialTitle = 'How to set up your drip campaign email'

export const dripEmailSupportTutorialSteps = [
  {
    title: 'Open the Email tab and change the template',
    description:
      'In your campaign, go to the Email tab. Click Change template to pick the look of your email (logo, colors, and layout).',
    imageSrc: step1ChangeTemplate,
    imageAlt: 'Email tab with the Change template button highlighted'
  },
  {
    title: 'Choose a template and apply it',
    description:
      'Browse your saved email templates, select the one you want, and click Apply template. Your campaign email will use that template.',
    imageSrc: step2ApplyDesign,
    imageAlt: 'Choose email template modal with Apply template highlighted'
  },
  {
    title: 'Go to Promotion and start the campaign',
    description:
      'Open the Promotion tab to review your offer settings, then click Start campaign when you are ready to send it to guests.',
    imageSrc: step3StartCampaign,
    imageAlt: 'Promotion tab with the Start campaign button highlighted'
  }
]

const EMAIL_SUPPORT_MEDIUMS = ['Email', 'EmailAndText', 'TextWithEmailFallback']

export function shouldShowEmailSupportTutorial(medium) {
  return EMAIL_SUPPORT_MEDIUMS.includes(medium)
}
